import React from "react";

import Project from "./project";

import INFO from "../../data/user";

import "./styles/allProjects.css";

const AllProjects = ({ limit, projects: projectsProp }) => {
	const source = projectsProp || INFO.projects;
	const projects = limit ? source.slice(0, limit) : source;
	return (
		<div className="all-projects-container">
			{projects.map((project, index) => (
				<div className="all-projects-project" key={index}>
					<Project
						logo={project.logo}
						image={project.image}
						title={project.title}
						description={project.description}
						enterprise={project.enterprise}
						linkText={project.linkText}
						link={project.link}
						liveLink={project.liveLink}
						liveText={project.liveText}
						tags={project.tags}
						impact={project.impact}
					/>
				</div>
			))}
		</div>
	);
};

export default AllProjects;
